// Admin -> Invites: who signed in without an invite and is waiting (newest first), as a summary. Letting them in,
// with credits, happens in Admin -> People (screens/People.tsx), which lists the same requests on top.
// GET /api/admin/access-requests.
import { api } from "../api";
import { Link } from "../router";
import type { AccessRequest } from "../types";
import { ErrorNote, Icon, Spinner, timeAgo, useLoad } from "./bits";

const SHOW = 3;

export function AccessRequests() {
  const { data, error, loading, reload } = useLoad<AccessRequest[]>(() => api.accessRequests(), []);
  return (
    <section className="invite-list access-requests" aria-labelledby="acc-h">
      <header className="section-head">
        <h2 id="acc-h">Access requests</h2>
        {data && <span className="muted">{data.length} waiting</span>}
      </header>
      {error && <ErrorNote text={`Couldn't load the requests. ${error}`} retry={reload} />}
      {loading && !data && <Spinner label="Loading" />}
      {data && !data.length && <p className="muted">Nobody is waiting. People who sign in without an invite show up here and in People.</p>}
      {!!data?.length && (
        <>
          <ul className="inv-rows">
            {data.slice(0, SHOW).map((r) => (
              <li key={r.userId} className="inv-row">
                <div className="inv-main">
                  <p className="inv-who">{r.name || r.email}</p>
                  <p className="inv-meta">{[r.name ? r.email : null, r.note, r.createdAt ? timeAgo(r.createdAt) : null].filter(Boolean).join(", ")}</p>
                </div>
              </li>
            ))}
          </ul>
          <Link to="/admin/people" className="btn btn-primary btn-small access-review">
            Review {data.length > SHOW ? `all ${data.length}` : data.length === 1 ? "it" : "them"} in People <Icon name="back" size={14} />
          </Link>
        </>
      )}
    </section>
  );
}
